module.exports = __webpack_public_path__ + "img/frontlogo.9007e136.png";